import "./nordic.ts";

/**
 * Login form: email/password validation, password show/hide, and honest
 * prototype notices — SSO, forgot-password, and submit all surface an inline
 * note that auth isn't backend-wired yet (no credentials are verified).
 */
const form = document.getElementById("loginForm") as HTMLFormElement | null;
if (form) {
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const notice = document.getElementById("notice");
  const noticeText = document.getElementById("noticeText");
  const fieldOf = (el: Element): Element | null => el.closest(".field");
  const showNotice = (html: string) => {
    if (noticeText) noticeText.innerHTML = html;
    notice?.classList.add("show");
  };

  for (const el of form.querySelectorAll<HTMLInputElement>("input")) {
    el.addEventListener("input", () => fieldOf(el)?.classList.remove("invalid"));
  }

  // password reveal
  const reveal = document.getElementById("reveal");
  const pw = document.getElementById("password") as HTMLInputElement | null;
  if (reveal && pw) {
    reveal.addEventListener("click", () => {
      const show = pw.type === "password";
      pw.type = show ? "text" : "password";
      reveal.setAttribute("aria-pressed", String(show));
      reveal.setAttribute("aria-label", show ? "Hide password" : "Show password");
    });
  }

  // SSO buttons — honest prototype behaviour
  for (const btn of document.querySelectorAll<HTMLElement>(".sso button")) {
    btn.addEventListener("click", () => {
      showNotice(
        `Single sign-on with <b>${btn.dataset.sso ?? ""}</b> isn’t wired up in this prototype yet. ` +
          `In production this would hand off to your identity provider. No account? ` +
          `<a href="/request-invitation">Request an invitation</a>.`,
      );
    });
  }

  document.getElementById("forgot")?.addEventListener("click", (e) => {
    e.preventDefault();
    showNotice("Password recovery isn’t connected in this prototype. Your IT admin manages access through your identity provider.");
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const problems: HTMLElement[] = [];
    const fail = (el: HTMLElement) => {
      fieldOf(el)?.classList.add("invalid");
      problems.push(el);
    };
    const email = document.getElementById("email") as HTMLInputElement;
    const password = document.getElementById("password") as HTMLInputElement;
    if (!emailRe.test(email.value.trim())) fail(email);
    if (!password.value) fail(password);
    if (problems.length) {
      problems[0].focus();
      return;
    }

    const btn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = ".7";
      btn.textContent = "Signing in…";
    }
    setTimeout(() => {
      if (btn) {
        btn.disabled = false;
        btn.style.opacity = "1";
        btn.textContent = "Sign in";
      }
      showNotice(
        `This is a front-end prototype — sign-in isn’t connected to a backend yet, so credentials aren’t verified. ` +
          `Need access to the real workspace? <a href="/request-invitation">Request an invitation</a>.`,
      );
    }, 850);
  });
}
